import { uploadData } from "aws-amplify/storage";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { DateTime } from "luxon";
import numeral from "numeral";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useUserStore } from "../../_store/userStore";
import api from "../../api/api.main";
import { PdfContext } from "./context/pdf.ctx";
import fontSarabunTH from "./font/fontSarabunTH";

function PdfDownload() {
  const userData = useUserStore((state) => state.userData);
  const [isSubmit, setIsSubmit] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [allPages, setAllPages] = useState(0);
  const [progress, setProgress] = useState(0);

  const pdfCtx = useContext(PdfContext);
  const pdfRef = useRef(null);

  const doc = useMemo(() => {
    return new jsPDF("p", "px", "a4");
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // for smooth scrolling
    });
    setTimeout(() => {
      setLoadingPage(false);
    }, 500);
    setTimeout(() => {
      const input = document.getElementById("pdf-content");
      const pages = input.querySelectorAll(".page");
      setAllPages(pages.length + 2);
    }, 1000);
  }, []);

  useEffect(() => {
    if (isSubmit) {
      doc.save("รายงานสรุป.pdf");
      setLoadingPDF(false);
      setProgress(0);
    }
  }, [isSubmit]);

  const generatePDF = async () => {
    if (loadingPDF) return;
    setIsSubmit(false);
    setLoadingPDF(true);
    pdfCtx.setPdfDate(new Date());

    const input = document.getElementById("pdf-content");

    doc.addFileToVFS("THSarabun.ttf", fontSarabunTH);
    doc.addFont("THSarabun.ttf", "THSarabun", "normal");
    doc.setFont("THSarabun");

    const pages = input.querySelectorAll(".page");

    for (let i = 0; i < pages.length; i++) {
      pdfRef.current += 1;
      const page = pages[i];
      const canvas = await html2canvas(pages[i], {
        scale: 1.7,
        useCORS: true,
      });
      const image = canvas.toDataURL("image/png");
      const isHorizontal = page.classList.contains("page-horizontal");

      if (i !== 0) {
        // doc.addPage(null, "p");
        if (isHorizontal) {
          doc.addPage(null, "l");
        } else {
          doc.addPage(null, "p");
        }
      }

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const widthRatio = pageWidth / canvas.width;
      const heightRatio = pageHeight / canvas.height;
      const ratio = Math.min(widthRatio, heightRatio);

      const canvasWidth = canvas.width * ratio;
      const canvasHeight = canvas.height * ratio;

      const marginX = (pageWidth - canvasWidth) / 2;
      const marginY = (pageHeight - canvasHeight) / 2;
      // console.error("Image size too large:", image.length);
      doc.addImage(image, "PNG", marginX, marginY, canvasWidth, canvasHeight);
      // setProgress((prev) => prev + 1);
    }

    const pdfBlob = doc.output("blob");
    await uploadData({
      key: `${userData?._id}.pdf`,
      data: pdfBlob,
    }).result;
    pdfRef.current += 1;
    // setProgress((prev) => prev + 1);

    await api.put(`/profiles/${userData._id}`, {
      is_export: true,
      export_date: DateTime.now().setZone("Asia/Bangkok").toISO(),
    });
    pdfRef.current += 1;
    // setProgress((prev) => prev + 1);
    setIsSubmit(true);

    // const input = document.getElementById("pdf-content");

    // const doc = new jsPDF("p", "px", "a4");
    // doc.addFileToVFS("THSarabun.ttf", fontSarabunTH);
    // doc.addFont("THSarabun.ttf", "THSarabun", "normal");
    // doc.setFont("THSarabun");

    // const pages = input.querySelectorAll(".page");

    // for (let i = 0; i < pages.length; i++) {
    //   const page = pages[i];
    //   const isHorizontal = page.classList.contains("page-horizontal");

    //   const canvas = await html2canvas(page, {
    //     scale: 1.7,
    //     useCORS: true,
    //   });
    //   const image = canvas.toDataURL("image/png");

    //   if (i !== 0) {
    //     // doc.addPage(null, "p");
    //     if (isHorizontal) {
    //       doc.addPage(null, "l");
    //     } else {
    //       doc.addPage(null, "p");
    //     }
    //   }

    //   const pageWidth = doc.internal.pageSize.getWidth();
    //   const pageHeight = doc.internal.pageSize.getHeight();

    //   const widthRatio = pageWidth / canvas.width;
    //   const heightRatio = pageHeight / canvas.height;
    //   const ratio = Math.min(widthRatio, heightRatio);

    //   const canvasWidth = canvas.width * ratio;
    //   const canvasHeight = canvas.height * ratio;

    //   const marginX = (pageWidth - canvasWidth) / 2;
    //   const marginY = (pageHeight - canvasHeight) / 2;
    //   doc.addImage(image, "PNG", marginX, marginY, canvasWidth, canvasHeight);
    // }

    // // doc.setProperties({
    // //   title: "invoice-pdf",
    // //   subject: "This is the subject",
    // //   author: "Author Name",
    // //   keywords: "generated, javascript, web 2.0, ajax",
    // //   creator: "kabir",
    // // });

    // const dataUri = doc.output("bloburi");
    // setPdfDataUri(dataUri);
  };

  const getProgressPercent = () => {
    const percent = (pdfRef.current / allPages) * 100;
    console.log("percent", percent);
    return percent > 100 ? 100 : numeral(percent).format("0.00");
  };

  return (
    <div className="fixed top-0 right-0 z-50">
      {allPages > 0 && (
        <button
          className="fixed top-4 right-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-lg transition-all duration-200 cursor-pointer px-6 py-3 flex items-center gap-2"
          onClick={generatePDF}
          disabled={loadingPage}
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
          {loadingPDF ? `${getProgressPercent()}/100 %` : "DownloadPDF"}
        </button>
      )}
    </div>
  );
}

export default PdfDownload;
